<template>
	<component :is="wrapTag" class="omapi-radio-group" :class="className">
		<common-selectable-input
			v-for="(option, index) in options"
			:key="index"
			:name="groupName"
			:type="type"
			:class="{ 'text-setting-indented': option.indented }"
			:checked="checked(option)"
			:value="option.value"
			:help="option.help"
			:title-tag="option.titleTag"
			v-on="$listeners"
		>
			{{ option.label }}
		</common-selectable-input>
	</component>
</template>

<script>
export default {
	props: {
		/**
		 * The input radio type
		 */
		type: {
			type: String,
			default: 'radio',
		},
		/**
		 * The group of input options
		 *
		 * Should look like: [
		 *     {
		 *         label: 'Pizza',
		 *         value: 'pizza',
		 *         checked: true
		 *         help: 'Only check if you truly love pizza.',
		 *         titleTag: 'Only check if you truly love pizza.',
		 *     },
		 *     // etc
		 * ]
		 *
		 * @type {Array}
		 */
		options: {
			type: Array,
			required: true,
			default() {
				return [];
			},
		},
		/**
		 * The "name" attribute for the options in the group.
		 */
		groupName: {
			type: String,
			required: true,
		},
		/**
		 * The "class" attribute, added to the omapi-radio-group wrapper.
		 */
		className: {
			type: String,
			default: '',
		},
		value: {
			type: Array,
			default: () => [],
		},
		wrapTag: {
			type: String,
			default: 'div',
		},
	},
	methods: {
		checked(option) {
			if (option.checked || option.selected) {
				return true;
			}

			if (!this.value || !this.value.length) {
				return false;
			}

			return this.value.includes(option.value);
		},
	},
};
</script>
